import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Popup} from '@tickchak/react-share/app';
import {TShow} from '../../../../hooks/useShow';
import * as css from './AdditionalInfoSheet.css';
import sanitizeHtml from '../../../../library/sanitizeHtml';

interface AdditionalInfoSheetProps {
    additionalInfo: string;
    show: TShow;
}

function AdditionalInfoSheet({additionalInfo, show}: AdditionalInfoSheetProps): React.ReactElement {
    const {t} = useTranslation('eTicket');

    return (
        <Popup show={show} data-cy="more-info-sheet">
            <css.panel>
                <css.handle aria-hidden />
                <css.head>
                    <css.title>{t('moreInfo')}</css.title>
                </css.head>
                <css.info dangerouslySetInnerHTML={sanitizeHtml(additionalInfo)} />
                <Button
                    variant="primary"
                    size="primary"
                    onClick={show.close}
                    data-cy="more-info-sheet-close"
                >
                    {t('moreInfoClose')}
                </Button>
            </css.panel>
        </Popup>
    );
}

export default AdditionalInfoSheet;
